import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.scss']
})
export class SiteFooterComponent implements OnInit, AfterViewInit {

    @ViewChild('myIdentifier') myIdentifier: ElementRef;
    @ViewChild('contactEl') contactEl: ElementRef;
    myInnerHeight: any = 180;

    copyrightDate: number;
    contact: any = {};
    footerItems: any = [];
    email: any = null;
    emailMobile: any = null;
    subscribedSuccess: boolean = false;
    subscribeError: any = '';

    constructor(private api: ApiService, private cd: ChangeDetectorRef, public router: Router,) { }

    ngOnInit(): void {

        this.copyrightDate = new Date().getFullYear();

        this.fetchContactInformation();
        this.fetchFooterItems();

    }

    ngAfterViewInit() {


        setTimeout(() => {
            this.getHeight();
        }, 2000);



    }

    getHeight() {
        if (this.myIdentifier?.nativeElement?.offsetHeight) {
            var height = this.myIdentifier.nativeElement.offsetHeight;
            this.myInnerHeight = height;
            this.cd.detectChanges();
        }

    }

    async fetchContactInformation() {

        await this.api.fetchContactInformation()
            .subscribe(res => {
                this.contact = res.data.item;
                this.cd.detectChanges();
            }, (err) => {

            });

    }




    async fetchFooterItems() {

        await this.api.fetchFooterItems()
            .subscribe(res => {
                this.footerItems = res.data.items;
                this.cd.detectChanges();


            }, (err) => {

            });


    }

    goTo(link) {
        this.router.navigateByUrl('/' + link);
    }

    subscribe() {
        this.subscribeError = '';
        this.subscribedSuccess = false;
        let email = null;
        if (this.validateEmail(this.email)) {
            email = this.email;
        } else if (this.validateEmail(this.emailMobile)) {
            email = this.emailMobile;
        } else {
            this.subscribeError = 'Please enter a valid email address';
        }

        if (email) {
            this.newsLetterSignup(email, null);
        }

    }


    async newsLetterSignup(email, name) {

        await this.api.add_to_mail_list(email, name)
            .subscribe(res => {
                this.subscribedSuccess = true;
                this.cd.detectChanges();
            }, (err) => {
                console.log(err);
            });
    }


    validateEmail(mail) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return (true)
        }
        return (false)
    }

}
